module.exports = __webpack_public_path__ + "img/rs.5097687.svg";